module.exports = __webpack_public_path__ + "img/ys_inc.79e1cbbd.svg";